import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { MOCKUP_URL, volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-317" data-mp="2x0qm3o2say8o">
      <div className="mx-auto max-w-6xl" data-id="element-318" data-mp="2x34ic097aght">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-319" data-mp="2t0g5lhhd8pfk">
          Everything You Need to Organize Your Motor Planning Workflow
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-navy/75" data-id="element-320" data-mp="2j9ljcd44dpu4">
          Your Complete 6-Volume Practical Blueprint. Each volume addresses a specific planning challenge and provides tools designed to produce a usable professional document.
        </p>
        <img src={MOCKUP_URL} alt="All six volumes of the blueprint" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-321" data-mp="25a41yit5leus" />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-322" data-mp="20b972ihwvzub">
          {volumes.map((v, i) => <article key={v.title} className="flex flex-col overflow-hidden rounded-3xl border border-brand/20 bg-cream" data-id="element-323" data-mp="334l2926k1r2s" data-mpi={i}>
              <div className="bg-brand px-5 py-4" data-id="element-324" data-mp="37xxdmam841dl">
                <p className="text-xs font-extrabold uppercase tracking-widest text-white/80" data-id="element-325" data-mp="2u57o3w7hkebq">Volume 0{i + 1}</p>
                <h3 className="mt-1 font-display text-xl font-extrabold leading-snug text-white" data-id="element-326" data-mp="2y5rp5av6k235">{v.title}</h3>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-327" data-mp="3lwn9xo17xx0w">
                <p className="font-semibold text-navy" data-id="element-328" data-mp="3qvqihigeqldm">{v.tagline}</p>
                <p className="mt-4 text-xs font-bold uppercase tracking-wider text-brand" data-id="element-329" data-mp="3qsui7nh37km0">Inside:</p>
                <ul className="mt-2 space-y-2" data-id="element-330" data-mp="3cxs2y9qcoiwj">
                  {v.items.map(it => <li key={it} className="flex gap-2 text-[15px] text-navy/85" data-id="element-331" data-mp="3hwmuq16aphss">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-332" data-mp="21ez4s117rnvk" />
                      {it}
                    </li>)}
                </ul>
                <div className="mt-auto pt-5" data-id="element-333" data-mp="byn7m1x5gop9">
                  <div className="flex gap-2 rounded-xl bg-accent-light p-3 text-sm text-navy" data-id="element-334" data-mp="70bwlnv4c85g">
                    <TrophyIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-dark" aria-hidden="true" data-id="element-335" data-mp="293l8ma8acpn" />
                    <span data-id="element-336" data-mp="3udnyqw6tzgpq"><strong data-id="element-337" data-mp="3udnziyennkqs">Your practical result:</strong> {v.result}</span>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCTA label="Get All 6 Volumes Now" data-id="element-338" data-mp="3kf84wlgf5tcj" />
      </div>
    </section>;
}